export default __webpack_public_path__ + "static/media/cover2.cc155be7.png";